<template>
  <FontAwesomeLayers class="stop-type-icon pickup">
    <FontAwesomeIcon
      v-if="solid"
      aria-hidden="true"
      icon="circle"
      transform="grow-16"
    />
    <FontAwesomeIcon
      aria-hidden="true"
      :icon="[solid ? 'fas' : 'fa', 'external-link']"
      transform="shrink-2"
      :class="solid ? 'solid-inverse' : ''"
    />
  </FontAwesomeLayers>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';

const props = defineProps({
  solid: {
    type: Boolean,
    default: false,
  },
});
const { solid } = toRefs(props);
</script>

<style>
.stop-type-icon.pickup {
  color: var(--stop-type-accent-color);

  .solid-inverse {
    color: #fff;
    font-weight: bolder;
  }
}
</style>
